"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandButton = void 0;
var ActionButton_1 = require("../ActionButton/ActionButton");
/**
 * {@docCategory Button}
 */
exports.CommandButton = ActionButton_1.ActionButton;
//# sourceMappingURL=CommandButton.js.map